import React from 'react';
import _ from 'lodash';
import {
  Stack,
  Typography,
  Box,
  Chip,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from '@mui/material';
import { SmallFormTextField } from '../../../../../../components/small-fields/SmallFormTextField';
import { DebounceInput } from 'react-debounce-input';
import { CssTextField } from '../../../../../../components/others/CssTextField';
import { SmallFormDateField } from '../../../../../../components/small-fields/SmallFormDateField';
import { useDidMountEffect } from '../../../../../../services/hooks';

export const OLPeriods = ({ formik, data, updateAgreementDates }) => {
  const updateTimedPeriodsCallback = newRow => {
    const clonePeriods = _.cloneDeep(formik.values.ol_timed_periods);
    const idx = _.findIndex(clonePeriods, obj => obj.id == newRow.id);

    clonePeriods[idx] = {
      ...clonePeriods[idx],
      remarks: newRow.remarks,
      events: newRow.events,
      nameWithEvents: newRow.nameWithEvents
    };

    formik.setFieldValue('ol_timed_periods', clonePeriods);
  };
  const updatePeriod = e => {
    const findRemovedPeriod = formik.values.ol_periods.filter(
      c => !e.target.value.includes(c)
    );
    if (_.isEmpty(findRemovedPeriod)) {
      formik.setFieldValue('ol_periods', e.target.value);
      const camp = _.filter(
        data.periods_choices,
        v => v.value == e.target.value[e.target.value.length - 1]
      )[0];
      formik.setFieldValue(
        'ol_timed_periods',
        [
          ...formik.values.ol_timed_periods,
          {
            id: camp.value,
            fixed_date: [camp.date_from, camp.date_to],
            actual_date: [camp.date_from, camp.date_to],
            remarks: '',
            name: camp.label
          }
        ].sort((a, b) => (a.fixed_date[0] < b.fixed_date[0] ? -1 : 1))
      );
      updateAgreementDates([
        ...formik.values.ol_timed_periods,
        {
          id: camp.value,
          fixed_date: [camp.date_from, camp.date_to],
          actual_date: [camp.date_from, camp.date_to],
          remarks: '',
          name: camp.label
        }
      ]);
    } else {
      formik.setFieldValue('ol_periods', e.target.value);
      formik.setFieldValue(
        'ol_timed_periods',
        _.filter(
          formik.values.ol_timed_periods,
          o => o.id != findRemovedPeriod[0]
        ).sort((a, b) => (a.fixed_date[0] < b.fixed_date ? -1 : 1))
      );
      updateAgreementDates(
        _.filter(
          formik.values.ol_timed_periods,
          o => o.id != findRemovedPeriod[0]
        )
      );
    }
  };

  return (
    <Stack
      direction="column"
      alignItems="left"
      justifyContent="center"
      spacing={2}
    >
      <Stack flex="1 1 30%">
        <SmallFormTextField
          name="ol_periods"
          select
          multiple
          placeholder=""
          value={formik.values.ol_periods}
          onChange={e => updatePeriod(e)}
          options={data.ol_periods_choices || []}
          sx={{ width: '100%' }}
          renderValue={selected => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map(value => {
                const choice = data.ol_periods_choices
                  ? data.ol_periods_choices.find(
                    element => value === element.value
                  )
                  : undefined;

                return <Chip key={value} label={choice?.label} />;
              })}
            </Box>
          )}
        />
      </Stack>
      <Stack flex="1 1 70%">
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: '20%' }} align="left">
                  Turnus
                </TableCell>
                <TableCell sx={{ width: '30%' }} align="left">
                  Data domyślna
                </TableCell>
                {/* <TableCell align="left">Data faktyczna</TableCell> */}
                <TableCell sx={{ width: '20%' }} align="left">
                  Uwagi
                </TableCell>
                <TableCell sx={{ width: '30%' }} align="left">
                  Imprezy
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {formik.values.ol_timed_periods &&
                formik.values.ol_timed_periods.map((row, key) => (
                  <Row
                    key={key}
                    row={row}
                    updateTimedPeriodsCallback={updateTimedPeriodsCallback}
                    eventChoices={data.event_choices}
                  />
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </Stack>
  );
};

function Row({ row, updateTimedPeriodsCallback, eventChoices }) {
  const [fixedDateFrom, setFixedDateFrom] = React.useState(row.fixed_date[0]);
  const [fixedDateTo, setFixedDateTo] = React.useState(row.fixed_date[1]);
  const [remarks, setRemarks] = React.useState(row.remarks);
  const [name, setName] = React.useState(row.name);
  const [updateSignal, setUpdateSignal] = React.useState(false);
  const [events, setEvents] = React.useState(Array.isArray(row.events) ? row.events : []);
  const prevEventsRef = React.useRef(events);
  React.useEffect(() => {
    if (remarks !== row.remarks) {
      setRemarks(row.remarks);
    }
    setName(row.name);
    setEvents(Array.isArray(row.events) ? row.events : []);
  }, [row]);

  const constructProduct = () => ({
    id: row.id,
    dateFrom: null,
    dateTo: null,
    remarks,
    events,
    nameWithEvents: buildNameWithEvents(name, events, eventChoices)
  });

  const renderMultiColumnValue = (selected, options) => {
    if (!options) {
      return;
    }
    const labels = options
      .filter(opt => selected.includes(opt.value))
      .map(opt => opt.label);

    const useColumns = labels.length > 3;

    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: useColumns ? 'repeat(2, minmax(0, 1fr))' : '1fr',
          columnGap: 12,
          rowGap: 6,
          whiteSpace: 'normal'
        }}
      >
        {labels.map(label => (
          <span
            key={label}
            style={{
              padding: '2px 6px',
              borderRadius: 4,
              backgroundColor: 'rgba(0,0,0,0.04)',
              fontSize: 13
            }}
          >
            {label}
          </span>
        ))}
      </div>
    );
  };

  const buildNameWithEvents = (baseName, selectedValues, options) => {
    if (!selectedValues || selectedValues.length === 0) {
      return baseName;
    }

    const labels = options
      .filter(opt => selectedValues.includes(opt.value))
      .map(opt => opt.label);

    return `${baseName} (${labels.join(', ')})`;
  };

  const handleEventsChange = values => {
    setEvents(values);
  };

  React.useEffect(() => {
    const prev = prevEventsRef.current;
    const isSame =
      prev.length === events.length &&
      prev.every(v => events.includes(v));
    if (!isSame) {
      updateTimedPeriodsCallback(constructProduct());
    }

    prevEventsRef.current = events;
  }, [events]);

  useDidMountEffect(() => {
    updateTimedPeriodsCallback(constructProduct());
  }, [updateSignal]);

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell align="left">
          <SmallFormTextField
            sx={{ width: '100%' }}
            c
            type="text"
            placeholder=""
            value={name}
            disabled={true}
          />
        </TableCell>
        <TableCell align="left">
          <Stack direction="row" alignItems="center" justifyContent="center">
            <SmallFormDateField
              type="text"
              placeholder="data od"
              value={fixedDateFrom}
              disabled={true}
            />
            <span style={{ marginTop: 15 }}>&nbsp;-&nbsp;</span>
            <SmallFormDateField
              type="text"
              placeholder="fixedDateTo"
              value={fixedDateTo}
              disabled={true}
            />
          </Stack>
        </TableCell>
        <TableCell align="left">
          <DebounceInput
            sx={{ width: '90%' }}
            name="remarks"
            debounceTimeout={600}
            value={remarks}
            element={CssTextField}
            onChange={e => {
              setRemarks(e.target.value);
              setUpdateSignal(!updateSignal);
            }}
            variant="outlined"
          />
        </TableCell>
        <TableCell align="left">
          <SmallFormTextField
            sx={{ width: '100%' }}
            select
            multiple
            id="events"
            name="events"
            options={eventChoices}
            value={events}
            onChange={e => handleEventsChange(e.target.value)}
            renderValue={selected => renderMultiColumnValue(selected, eventChoices)}
          />
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
